import { useLayoutMode } from "../hooks/useLayoutMode";
import { UiLoadProvider } from "../context/UiLoadContext";
import { DesktopShell } from "./DesktopShell";
import { MobileShell } from "./MobileShell";

export function LayoutRouter() {
  const { mode } = useLayoutMode();
  return (
    <UiLoadProvider>
      {mode === "mobile" ? <MobileShell /> : <DesktopShell />}
    </UiLoadProvider>
  );
}
